import Slider from "react-slick";
import { CampaignSliderArrow, Card } from "components/UI/atoms";
import { CardBrand } from "components/UI/molecules";
import "./index.scss";
import { NavLink } from "hooks/useCustomNavigation";
import { INTERNAL_PATHS } from "routes/paths";
import { useSlidesToShow } from "./utils/useSlidesToShow";

export const CampaignSlider = ({
  centered = false,
  seeAll = true,
  brands = [],
  title = ""
}) => {
  const { numberOfSlidesToShow, isMobile } = useSlidesToShow();
  const hasMinimiumOfItens = brands.length <= numberOfSlidesToShow;
  const slidesToScroll = () => {
    if (isMobile) return 1.5;

    return hasMinimiumOfItens ? 0 : numberOfSlidesToShow;
  };
  const sliderSettings = {
    dots: false,
    infinite: false,
    autoplay: false,
    slidesToShow: numberOfSlidesToShow,
    slidesToScroll: slidesToScroll(),
    arrows: !hasMinimiumOfItens,
    nextArrow: <CampaignSliderArrow />,
    prevArrow: <CampaignSliderArrow />
  };

  return (
    <Card
      customClassName={`slider-container ${
        hasMinimiumOfItens ? "slide-short" : ""
      }`}
    >
      <div className="slider-header">
        <h2 className={`slider-title ${centered ? "centered" : ""}`}>
          {title}
        </h2>
        {seeAll && (
          <div className="slider-navigation">
            <NavLink
              to={INTERNAL_PATHS.BUY_GIFT_CARDS}
              className="anchor-see-all"
            >
              See all
            </NavLink>
          </div>
        )}
      </div>
      <Slider {...sliderSettings}>
        {brands.map((item) => (
          <div key={item.brandName} data-testid="slider-item">
            <CardBrand
              {...item}
              key={item.brandName}
              customClassName="carousel-brand"
            />
          </div>
        ))}
      </Slider>
    </Card>
  );
};
